import React from 'react';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { KPI } from '../data/mockData';
import { SparklineChart } from './SparklineChart';
import { getTrendColor } from '../utils/helpers';
interface KPICardsProps {
  kpis: KPI[];
}
export function KPICards({
  kpis
}: KPICardsProps) {
  return <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 xl:grid-cols-10 gap-3 mb-6" data-id="element-116">
      {kpis.map(kpi => {
      const trendColorClass = getTrendColor(kpi.trend, kpi.id);
      const TrendIcon = kpi.trend === 'up' ? ArrowUpRight : ArrowDownRight;
      // Extract hex color for recharts based on tailwind class
      const strokeColor = trendColorClass.includes('green') ? '#22c55e' : '#ef4444';
      return <div key={kpi.id} className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 flex flex-col" data-id="element-117">
            <h3 className="text-xs uppercase tracking-wide text-gray-500 mb-2 truncate" title={kpi.label} data-id="element-118">
              {kpi.label}
            </h3>
            <div className="text-2xl font-bold text-gray-900 mb-2" data-id="element-119">
              {kpi.formattedValue}
            </div>
            <div className="flex items-center mb-3" data-id="element-120">
              <TrendIcon className={`w-4 h-4 ${trendColorClass} mr-1`} data-id="element-121" />
              <span className={`text-sm font-medium ${trendColorClass}`} data-id="element-122">
                {Math.abs(kpi.change)}%
              </span>
              <span className="text-xs text-gray-400 ml-2" data-id="element-123">vs last</span>
            </div>
            <div className="mt-auto" data-id="element-124">
              <SparklineChart data={kpi.sparklineData} color={strokeColor} data-id="element-125" />
            </div>
          </div>;
    })}
    </div>;
}